module.exports = __webpack_public_path__ + "static/img/kids_6.0ba631de.png";